import { bootstrapModule } from './bootstrap.module';
import { UIRouterRxPlugin } from '@uirouter/rx';
import { UIRouter } from '@uirouter/core';

/** Register the @uirouter/rx plugin to add observables for state changes, i.e., `router.globals.start$` */
bootstrapModule.config(($uiRouterProvider: UIRouter) => {
  'ngInject';
  $uiRouterProvider.plugin(UIRouterRxPlugin);
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/bootstrap/uiRouterRxjs.ts